"use client";

import { useEffect } from "react";
import type { ReactElement } from "react";
import { type MarketingTrackFunnel, trackMarketingEvent } from "./track";

/**
 * Sends one funnel page-view on mount. Renders nothing.
 */
export function MarketingPageView({
  funnel,
  step,
}: {
  readonly funnel: MarketingTrackFunnel;
  readonly step: number;
}): ReactElement | null {
  useEffect(() => {
    trackMarketingEvent({ funnel, step });
  }, [funnel, step]);
  return null;
}
